export enum MonetizableType {
  NO = 'no',
  NO_BECAUSE_OF_LEAD = 'no_because_of_lead',
  NO_BECAUSE_OF_LIMIT = 'no_because_of_limit',
  YES_ASSUMED = 'yes_assumed',
}

export const ALL_MONETIZABLE_TYPES = Object.values(MonetizableType);
